import { memo } from "react";

import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import {
    getGamificationTemplates,
    getIOSAppDetails,
    getLeadCustomSources,
} from "../../../../../../redux/slices/landingPages/landingPages.asyncActions";
import ConnectionsStep from "./ConnectionsStep.layout";

const mapStateToProps = (state: any) => ({
    templates: state.landingPages.templates,

    trackers: state.allTrackersState.trackers,
    mmpDetails: state.landingPages.mmpDetails,
    appDetails: state.landingPages.appDetails,

    gamificationTemplates: state.landingPages.gamificationTemplates,

    customSources: state.landingPages.customSources,
});

const mapDispatchToProps = (dispatch: any): any => ({
    dispatchGetAppDetails: (iosAppId: any) =>
        dispatch(getIOSAppDetails(iosAppId)),
    dispatchGetGamificationTemplates: () =>
        dispatch(getGamificationTemplates()),
    dispatchLeadCustomSources: () => dispatch(getLeadCustomSources()),
});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(memo(ConnectionsStep));
